import React from 'react'
import SocialLinks from '../components/sociallinks/SocialLinks'
import NavBar from '../components/navbar/NavBar'
import Footer from '../components/footer/Footer'
import Avatar01 from '../assets/avatars/avatar-01.svg'
import Avatar02 from '../assets/avatars/avatar-02.svg'
import Avatar03 from '../assets/avatars/avatar-03.svg'
import Avatar04 from '../assets/avatars/avatar-04.svg'
import Avatar05 from '../assets/avatars/avatar-05.svg'

const Team = () => {
    return (
        <>
            <SocialLinks />
            <NavBar />
            <div className="container">
                <div className="team-main">
                    <div className="team-sub">
                        <div className="team-item">
                            <img src={Avatar01} alt="" />
                            <h4>SafePizza CEO</h4>
                            <h5><a href="mailto:info@safe-pizza.com">info@safe-pizza.com</a></h5>
                        </div>
                        <div className="team-item">
                            <img src={Avatar02} alt="" />
                            <h4>SafePizza CTO</h4>
                            <h5><a href="mailto:admin@safe-pizza.com">admin@safe-pizza.com</a></h5>
                        </div>
                        <div className="team-item">
                            <img src={Avatar03} alt="" />
                            <h4>SafePizza Ops</h4>
                            <h5><a href="mailto:ops@safe-pizza.com">ops@safe-pizza.com</a></h5>
                        </div>
                        <div className="team-item">
                            <img src={Avatar04} alt="" />
                            <h4>SafePizza Tech</h4>
                            <h5><a href="mailto:techsupport@safe-pizza.com">techsupport@safe-pizza.com</a></h5>
                        </div>
                        <div className="team-item">
                            <img src={Avatar05} alt="" />
                            <h4>SafePizza Group Admin</h4>
                            <h5><a href="mailto:groupadmin@safe-pizza.com">groupadmin@safe-pizza.com</a></h5>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Team
